/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type DeclinedJobsCountyDimension =
  (typeof DeclinedJobsCountyDimension)[keyof typeof DeclinedJobsCountyDimension];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeclinedJobsCountyDimension = {
  HomeCounty: 0,
  FromCounty: 1,
  ToCounty: 2,
} as const;
